import { makeStyles, Theme, darken } from '@material-ui/core/styles';
import { blackHaze, carmine, gainsboro, orange, steelblue } from 'styles/abstract/variables';

// TODO PB Styles moved to styles/components/chips.ts.
export const makeChipClasses = makeStyles({
    root: {
        margin: '0.5rem 0.5rem 0 0',
    },
});

export const makeCoverStyles = makeStyles({
    cover: {
        maxWidth: '100%',

        '&:hover': {
            cursor: 'pointer',
        },
    },
});

export const makeDetailsStyles = makeStyles((theme: Theme) => ({
    paragraph: {
        fontWeight: 600,
    },
    table: {
        width: '100%',

        [theme.breakpoints.down('xs')]: {
            flexDirection: 'column',
        },
    },
    tableData: {
        border: `0.0625rem solid ${gainsboro}`,
        padding: theme.spacing(0.5, 1),

        '&.header': {
            backgroundColor: blackHaze,
            textAlign: 'right',
            textTransform: 'lowercase',

            [theme.breakpoints.down('xs')]: {
                textAlign: 'left',
            },

            '&.capitalize': {
                textTransform: 'capitalize',
            },
        },
    },
    tableWrapper: {
        width: '100%',
    },
    wrapper: {
        marginTop: '2rem',
    },
}));

export const makeMultimediaStyles = makeStyles((theme: Theme) => ({
    appLink: {
        color: steelblue,
        display: 'flex',
        fontSize: '1rem',
        justifyContent: 'center',
        marginTop: theme.spacing(2),
        textDecoration: 'none',
        transition: 'all 0.3s ease',
        width: '100%',

        '&:hover': {
            color: darken(steelblue, 0.3),
        },
    },
    supportedSystem: {
        alignItems: 'center',
        flex: 1,
        flexDirection: 'column',
        display: 'flex',
    },
    supportedSystems: {
        display: 'flex',
    },
    supportedSystemsInfo: {
        marginBottom: theme.spacing(2),
        textAlign: 'center',
    },
    supportedSystemsWrapper: {
        display: 'flex',
        flexDirection: 'column',
        margin: '2rem auto 0',
        maxWidth: '14rem',
    },
}));

export const makeOutlinedInputClasses = makeStyles({
    root: {
        marginRight: '1rem',

        '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: orange,
        },

        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: orange,
            borderWidth: '0.0625rem',
        },
    },
});

export const makePricePanelStyles = makeStyles({
    cover: {
        border: `0.0625rem solid ${gainsboro}`,
        borderRadius: '0.25rem',
        maxWidth: '100%',
    },
    // TODO EI iconWrapper styles moved to components/icon.
    iconWrapper: {
        display: 'flex',
        marginRight: '0.25rem',
    },
    // TODO EI iconWrapper styles moved to components/input.
    input: {
        padding: '0.625rem 1rem',
        width: '3rem',

        '&[type="number"]': {
            padding: '0rem 0.2rem 0rem 1rem',
            width: '3.8rem',
            height: '2.4rem'
        }
    },
    priceBox: {
        fontSize: '2rem',
        position: 'absolute',
        right: 0,
        top: '-3.5rem',
    },
    warning: {
        bottom: '-1.5rem',
        color: carmine,
        fontSize: '0.75rem',
        position: 'absolute',
    },
});
